import React from 'react';
import goalVision from '../../../images/goal-vision.svg';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router';
import TorontoFooter from '../../Layout/TorontoFooter';
import SFFooter from '../../Layout/SFFooter';
import NYCFooter from '../../Layout/NYCFooter';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet';

const GoalVision = props => {
  const history = useHistory();
  const isMobile = window.innerWidth < 768;

  return (
    <Fragment>
      <Helmet>
        <title>Autzu | Goals & Vision</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="resourcePageWide container">
        <div className="backToNewsroom">
          <FontAwesomeIcon
            className="backButton"
            icon={faArrowLeft}
            onClick={evt => {
              history.push('/newsroom');
              evt.stopPropagation();
            }}
          />
          <div onClick={() => history.push('/newsroom')}>Newsroom</div>
        </div>
        <div className="resourceTitle">Goals & Vision</div>
        <img src={goalVision} className="aboutAutzuImg"></img>
        <div className="aboutTextContainer">
          <div className="aboutSubTitle">Vision statement</div>
          <div className="aboutContent">
            Our vision is to be a global leader in the transportation
            industry, creating a world where sustainable transportation is
            accessible to all, reducing urban carbon emissions, and
            improving the quality of life in cities through the mass
            deployment of electric autonomous vehicles, with a centralized
            platform for managing and optimizing the fleet, and necessary
            charging and maintenance infrastructure, and maximizing the
            utilization of vehicles through multiple dispatching platforms.
            We believe in shaping the future of urban mobility and make it
            more efficient, sustainable, and accessible for all.
          </div>
        </div>
        <div className="aboutTextContainerGrey">
          <div className="greyTextBox">
            {' '}
            <div className="aboutSubTitle">Near-term goals</div>
            <div className="aboutContent">
              In the short term, Autzu aims to launch a global EV program
              designed to reduce the carbon footprint of rideshare vehicles
              in major cities. By collaborating with prominent ride-sharing
              companies and promoting the adoption of electric vehicles for
              drivers, we strive to make sustainable transportation more
              accessible. To further support this goal, we plan to
              establish charging and maintenance networks in key urban
              locations. Our focus is to eliminate the need for commercial
              car ownership for rideshare drivers by offering affordable EV
              car-sharing solutions.
            </div>
          </div>
        </div>

        <div
          className="aboutTextContainer"
          style={{
            borderBottom: isMobile ? '1px solid #414141' : 'none'
          }}>
          <div className="aboutSubTitle">Long-term goals</div>
          <div className="aboutContent">
            Autzu's long-term targets emphasize constructing the essential
            infrastructure for managing and controlling mass autonomous
            rideshare fleets. By optimizing fleet utilization and
            connecting vehicles to all available dispatching platforms, we
            aim to revolutionize the transportation landscape with a
            seamless, efficient, and sustainable autonomous rideshare
            system. This approach will contribute to a significant
            reduction in urban congestion and carbon emissions, ultimately
            enhancing the quality of life in cities across the globe.
          </div>
        </div>
      </div>
      <TorontoFooter />
    </Fragment>
  );
};

export default GoalVision;



// WEBPACK FOOTER //
// ./src/components/Newsroom/GoalVision/index.js